import React, { useState, useEffect } from 'react';
import './AdminEmploiDuTemps.css';
import DashboardHeader from '../components/DashboardHeader';
import AdminNavigationBar from '../components/AdminNavigationBar';

function AdminEmploiDuTemps() {
  const [currentView, setCurrentView] = useState('Semaine');
  const [selectedClasse, setSelectedClasse] = useState('6ème');
  const [anneeScolaire] = useState('2024-2025');
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedCours, setSelectedCours] = useState(null);
  const [selectedSlot, setSelectedSlot] = useState(null);
  const [cours, setCours] = useState([]);
  const [classes, setClasses] = useState([]);
  const [enseignants, setEnseignants] = useState([]);
  const [matieres, setMatieres] = useState([]);
  const [statutPublication, setStatutPublication] = useState(null);
  const [loading, setLoading] = useState(false);
  
  const [formData, setFormData] = useState({
    jour: '',
    heure_debut: '',
    heure_fin: '',
    matiere: '',
    enseignant_id: '',
    salle: ''
  });

  const days = [
    { label: 'Lundi', value: 'lundi', date: 21 },
    { label: 'Mardi', value: 'mardi', date: 22 },
    { label: 'Mercredi', value: 'mercredi', date: 23 },
    { label: 'Jeudi', value: 'jeudi', date: 24 },
    { label: 'Vendredi', value: 'vendredi', date: 25 },
    { label: 'Samedi', value: 'samedi', date: 26 }
  ];

  const hours = ['08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19'];

  useEffect(() => {
    fetchClasses();
    fetchEnseignants();
    fetchMatieres();
    fetchCours();
    fetchStatutPublication();
  }, [selectedClasse, anneeScolaire]);

  const fetchClasses = async () => {
    // Simulation - remplacer par l'API
    const mockClasses = [
      '6ème', '5ème', '4ème', '3ème',
      'Seconde C', 'Seconde D', 'Première C', 'Première D', 'Terminale C', 'Terminale D',
      'CB/F4/BTP', 'EL/EA/F3', 'IMI/DWM', 'MM-V', 'HR/Tourisme', 'G2/Com', 'OG', 'MA',
      'Stylisme/Modélisme', 'Secrétariat', 'Électricité Bâtiment', 'Cuisine/Pâtisserie/Bar'
    ];
    setClasses(mockClasses);
  };

  const fetchEnseignants = async () => {
    try {
      const response = await fetch('http://127.0.0.1:8000/api/v1/admin/enseignants');
      const data = await response.json();
      setEnseignants(data.data || data || []);
    } catch (error) {
      console.error('Erreur lors du chargement des enseignants:', error);
      setEnseignants([]);
    }
  };

  const fetchMatieres = async () => {
    const mockMatieres = [
      'Mathématiques', 'Physique-Chimie', 'SVT', 'Français', 'Anglais',
      'Espagnol', 'Histoire-Géographie', 'Philosophie', 'EPS', 'Arts Plastiques',
      'Informatique', 'Électrotechnique', 'Mécanique', 'Cuisine', 'Stylisme'
    ];
    setMatieres(mockMatieres);
  };

  const fetchCours = async () => {
    try {
      const response = await fetch(
        `http://127.0.0.1:8000/api/v1/admin/emplois-du-temps/classe/${selectedClasse}/${anneeScolaire}`
      );
      const data = await response.json();
      
      // Convertir l'objet groupé par jour en tableau
      const coursArray = [];
      Object.keys(data).forEach(jour => {
        data[jour].forEach(cours => {
          coursArray.push({
            ...cours,
            color: getRandomColor()
          });
        });
      });
      
      setCours(coursArray);
    } catch (error) {
      console.error('Erreur lors du chargement des cours:', error);
      setCours([]);
    }
  };

  const fetchStatutPublication = async () => {
    try {
      const response = await fetch(
        `http://127.0.0.1:8000/api/v1/admin/emplois-du-temps/statut/${selectedClasse}/${anneeScolaire}`
      );
      const data = await response.json();
      setStatutPublication(data);
    } catch (error) {
      console.error('Erreur lors du chargement du statut:', error);
      setStatutPublication(null);
    }
  };

  const handleSlotClick = (jour, heure) => {
    setSelectedSlot({ jour, heure });
    setFormData({
      jour,
      heure_debut: `${heure}:00`,
      heure_fin: `${parseInt(heure) + 1}:00`,
      matiere: '',
      enseignant_id: '',
      salle: ''
    });
    setShowAddModal(true);
  };

  const handleCoursClick = (coursItem) => {
    setSelectedCours(coursItem);
    setFormData({
      jour: coursItem.jour,
      heure_debut: coursItem.heure_debut,
      heure_fin: coursItem.heure_fin,
      matiere: coursItem.matiere,
      enseignant_id: coursItem.enseignant?.id || '',
      salle: coursItem.salle || ''
    });
    setShowEditModal(true);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmitAdd = async (e) => {
    e.preventDefault();
    
    try {
      setLoading(true);
      
      const response = await fetch('http://127.0.0.1:8000/api/v1/admin/emplois-du-temps', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          ...formData,
          classe: selectedClasse,
          annee_scolaire: anneeScolaire
        })
      });

      const data = await response.json();

      if (response.ok) {
        alert('✅ Cours ajouté avec succès!');
        setShowAddModal(false);
        fetchCours();
        fetchStatutPublication();
        
        // Réinitialiser le formulaire
        setFormData({
          jour: '',
          heure_debut: '',
          heure_fin: '',
          matiere: '',
          enseignant_id: '',
          salle: ''
        });
      } else {
        alert(`❌ ${data.message || 'Erreur lors de l\'ajout du cours'}`);
      }
    } catch (error) {
      console.error('Erreur:', error);
      alert('Erreur lors de l\'ajout du cours');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmitEdit = async (e) => {
    e.preventDefault();
    
    try {
      setLoading(true);
      
      const response = await fetch(`http://127.0.0.1:8000/api/v1/admin/emplois-du-temps/${selectedCours.id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });

      const data = await response.json();

      if (response.ok) {
        alert('✅ Cours modifié avec succès!');
        setShowEditModal(false);
        setSelectedCours(null);
        fetchCours();
      } else {
        alert(`❌ ${data.message || 'Erreur lors de la modification du cours'}`);
      }
    } catch (error) {
      console.error('Erreur:', error);
      alert('Erreur lors de la modification du cours');
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteCours = async () => {
    if (!window.confirm('Êtes-vous sûr de vouloir supprimer ce cours ?')) return;

    try {
      setLoading(true);
      
      const response = await fetch(`http://127.0.0.1:8000/api/v1/admin/emplois-du-temps/${selectedCours.id}`, {
        method: 'DELETE'
      });

      if (response.ok) {
        alert('✅ Cours supprimé avec succès!');
        setShowEditModal(false);
        setSelectedCours(null);
        fetchCours();
        fetchStatutPublication();
      } else {
        alert('❌ Erreur lors de la suppression du cours');
      }
    } catch (error) {
      console.error('Erreur:', error);
      alert('Erreur lors de la suppression du cours');
    } finally {
      setLoading(false);
    }
  };

  const getCoursForSlot = (jour, heure) => {
    return cours.find(c => {
      const coursHeure = parseInt(c.heure_debut.split(':')[0]);
      const slotHeure = parseInt(heure);
      const coursHeureFin = parseInt(c.heure_fin.split(':')[0]);
      
      return c.jour === jour && slotHeure >= coursHeure && slotHeure < coursHeureFin;
    });
  };

  const getCoursHeight = (coursItem) => {
    const debut = parseInt(coursItem.heure_debut.split(':')[0]);
    const fin = parseInt(coursItem.heure_fin.split(':')[0]);
    return (fin - debut) * 60;
  };

  const getCoursTop = (coursItem) => {
    const debut = parseInt(coursItem.heure_debut.split(':')[0]);
    const firstHour = parseInt(hours[0]);
    return (debut - firstHour) * 60;
  };

  const getRandomColor = () => {
    const colors = ['#4CAF50', '#FF6B6B', '#FF9800', '#FFC107', '#9C27B0', '#E91E63', '#00BCD4', '#3F51B5'];
    return colors[Math.floor(Math.random() * colors.length)];
  };

  const handlePublier = async () => {
    if (cours.length === 0) {
      alert('⚠️ Aucun cours à publier. Ajoutez d\'abord des cours à l\'emploi du temps.');
      return;
    }

    if (!window.confirm(`Publier l'emploi du temps de la classe ${selectedClasse} ?\n\nTous les élèves de cette classe recevront une notification.`)) {
      return;
    }

    try {
      setLoading(true);
      const response = await fetch('http://127.0.0.1:8000/api/v1/admin/emplois-du-temps/publier', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          classe: selectedClasse,
          annee_scolaire: anneeScolaire
        })
      });

      const data = await response.json();

      if (response.ok) {
        alert(`✅ ${data.message}\n\n${data.notifications_envoyees} notifications envoyées aux élèves de ${data.classe}`);
        fetchStatutPublication();
      } else {
        alert(`❌ ${data.message || 'Erreur lors de la publication'}`);
      }
    } catch (error) {
      console.error('Erreur:', error);
      alert('Erreur lors de la publication de l\'emploi du temps');
    } finally {
      setLoading(false);
    }
  };

  const handleDepublier = async () => {
    if (!window.confirm(`Dépublier l'emploi du temps de la classe ${selectedClasse} ?\n\nL'emploi du temps ne sera plus visible par les élèves.`)) {
      return;
    }

    try {
      setLoading(true);
      const response = await fetch('http://127.0.0.1:8000/api/v1/admin/emplois-du-temps/depublier', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          classe: selectedClasse,
          annee_scolaire: anneeScolaire
        })
      });

      const data = await response.json();

      if (response.ok) {
        alert(`✅ ${data.message}`);
        fetchStatutPublication();
      } else {
        alert(`❌ ${data.message || 'Erreur lors de la dépublication'}`);
      }
    } catch (error) {
      console.error('Erreur:', error);
      alert('Erreur lors de la dépublication de l\'emploi du temps');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-layout">
      <DashboardHeader />
      <AdminNavigationBar 
        title="Emploi du temps" 
        onBack={() => window.navigateTo && window.navigateTo('admin-dashboard')}
      />
      <div className="admin-container">
        <main className="admin-content admin-content-full">
          <div className="emploi-content">
            <div className="emploi-card">
              {/* Toolbar */}
              <div className="emploi-toolbar">
                <div className="toolbar-left">
                  <div className="classe-selector">
                    <label>Classe:</label>
                    <select 
                      value={selectedClasse} 
                      onChange={(e) => setSelectedClasse(e.target.value)}
                      className="classe-select"
                    >
                      {Array.isArray(classes) && classes.map((classe, index) => (
                        <option key={index} value={typeof classe === 'object' ? classe.nom : classe}>
                          {typeof classe === 'object' ? classe.nom : classe}
                        </option>
                      ))}
                    </select>
                  </div>
                  {statutPublication && (
                    <div className={`statut-badge-emploi ${statutPublication.est_publie ? 'publie' : 'brouillon'}`}>
                      {statutPublication.est_publie ? '✅ Publié' : '📝 Brouillon'}
                    </div>
                  )}
                </div>

                <div className="toolbar-right">
                  {statutPublication?.est_publie ? (
                    <button 
                      className="btn-depublier" 
                      onClick={handleDepublier}
                      disabled={loading}
                    >
                      🔒 Dépublier
                    </button>
                  ) : (
                    <button 
                      className="btn-publier" 
                      onClick={handlePublier}
                      disabled={loading || cours.length === 0}
                    >
                      📤 Publier pour les élèves
                    </button>
                  )}
                  <button className="btn-add-cours" onClick={() => setShowAddModal(true)}>
                    ➕ Ajouter un cours
                  </button>
                  <button className="btn-refresh" onClick={fetchCours}>
                    🔄
                  </button>
                </div>
              </div>

              {/* Calendar Header */}
              <div className="calendar-header-emploi">
                <div className="calendar-left">
                  <span className="today-label">Année scolaire: {anneeScolaire}</span>
                </div>
                <div className="calendar-center">
                  <button className="nav-arrow-btn">‹</button>
                  <span className="date-range">Oct 21 - 27, 2024</span>
                  <button className="nav-arrow-btn">›</button>
                </div>
                <div className="calendar-right">
                  <div className="view-tabs">
                    <button className={`view-tab ${currentView === 'Semaine' ? 'active' : ''}`} onClick={() => setCurrentView('Semaine')}>
                      Semaine
                    </button>
                    <button className={`view-tab ${currentView === 'Mois' ? 'active' : ''}`} onClick={() => setCurrentView('Mois')}>
                      Mois
                    </button>
                  </div>
                </div>
              </div>

              {/* Calendar Grid */}
              <div className="calendar-grid-emploi">
                {/* Time column */}
                <div className="time-column">
                  <div className="time-header">
                    <span className="clock-icon">🕐</span>
                  </div>
                  {hours.map((hour) => (
                    <div key={hour} className="time-slot">
                      {hour}h
                    </div>
                  ))}
                </div>

                {/* Days columns */}
                {days.map((day) => (
                  <div key={day.value} className="day-column">
                    <div className="day-header">
                      <div className="day-name">{day.label}</div>
                      <div className="day-number">{day.date}</div>
                    </div>
                    <div className="day-slots">
                      {hours.map((hour) => {
                        const coursInSlot = getCoursForSlot(day.value, hour);
                        const isFirstSlot = coursInSlot && parseInt(coursInSlot.heure_debut.split(':')[0]) === parseInt(hour);
                        
                        return (
                          <div 
                            key={`${day.value}-${hour}`} 
                            className={`hour-slot ${coursInSlot ? 'has-cours' : ''}`}
                            onClick={() => !coursInSlot && handleSlotClick(day.value, hour)}
                          >
                            {isFirstSlot && (
                              <div 
                                className="cours-block"
                                style={{
                                  height: `${getCoursHeight(coursInSlot)}px`,
                                  backgroundColor: coursInSlot.color,
                                  borderLeftColor: coursInSlot.color
                                }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleCoursClick(coursInSlot);
                                }}
                              >
                                <div className="cours-time">
                                  {coursInSlot.heure_debut} - {coursInSlot.heure_fin}
                                </div>
                                <div className="cours-matiere">{coursInSlot.matiere}</div>
                                <div className="cours-enseignant">{coursInSlot.enseignant?.nom}</div>
                                <div className="cours-salle">📍 {coursInSlot.salle}</div>
                              </div>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                ))}
              </div>

              {/* Légende */}
              <div className="emploi-legend">
                <p className="legend-text">💡 Cliquez sur une case vide pour ajouter un cours</p>
                <p className="legend-text">✏️ Cliquez sur un cours pour le modifier ou le supprimer</p>
              </div>
            </div>
          </div>
        </main>
      </div>

      {/* Modal Ajout */}
      {showAddModal && (
        <div className="modal-overlay-emploi" onClick={() => setShowAddModal(false)}>
          <div className="modal-content-emploi" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close-btn" onClick={() => setShowAddModal(false)}>✕</button>
            
            <h2 className="modal-title">Ajouter un cours</h2>
            <p className="modal-subtitle">Classe: {selectedClasse}</p>
            
            <form onSubmit={handleSubmitAdd} className="emploi-form">
              <div className="form-row">
                <div className="form-group">
                  <label>Jour <span className="required">*</span></label>
                  <select name="jour" value={formData.jour} onChange={handleInputChange} required>
                    <option value="">Sélectionner</option>
                    {days.map(day => (
                      <option key={day.value} value={day.value}>{day.label}</option>
                    ))}
                  </select>
                </div>

                <div className="form-group">
                  <label>Heure début <span className="required">*</span></label>
                  <input 
                    type="time" 
                    name="heure_debut" 
                    value={formData.heure_debut} 
                    onChange={handleInputChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label>Heure fin <span className="required">*</span></label>
                  <input 
                    type="time" 
                    name="heure_fin" 
                    value={formData.heure_fin} 
                    onChange={handleInputChange}
                    required
                  />
                </div>
              </div>

              <div className="form-group">
                <label>Matière <span className="required">*</span></label>
                <select name="matiere" value={formData.matiere} onChange={handleInputChange} required>
                  <option value="">Sélectionner une matière</option>
                  {matieres.map((matiere, index) => (
                    <option key={index} value={matiere}>{matiere}</option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <label>Enseignant</label>
                <select name="enseignant_id" value={formData.enseignant_id} onChange={handleInputChange}>
                  <option value="">Sélectionner un enseignant</option>
                  {enseignants.map(ens => (
                    <option key={ens.id} value={ens.id}>{ens.nom} - {ens.matiere}</option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <label>Salle</label>
                <input 
                  type="text" 
                  name="salle" 
                  value={formData.salle} 
                  onChange={handleInputChange}
                  placeholder="Ex: Salle 101, Labo 1"
                />
              </div>

              <div className="form-actions">
                <button type="button" className="btn-cancel" onClick={() => setShowAddModal(false)}>
                  Annuler
                </button>
                <button type="submit" className="btn-submit">
                  Ajouter le cours
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Modal Modification */}
      {showEditModal && selectedCours && (
        <div className="modal-overlay-emploi" onClick={() => setShowEditModal(false)}>
          <div className="modal-content-emploi" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close-btn" onClick={() => setShowEditModal(false)}>✕</button>
            
            <h2 className="modal-title">Modifier le cours</h2>
            <p className="modal-subtitle">Classe: {selectedClasse}</p>
            
            <form onSubmit={handleSubmitEdit} className="emploi-form">
              <div className="form-row">
                <div className="form-group">
                  <label>Jour <span className="required">*</span></label>
                  <select name="jour" value={formData.jour} onChange={handleInputChange} required>
                    {days.map(day => (
                      <option key={day.value} value={day.value}>{day.label}</option>
                    ))}
                  </select>
                </div>

                <div className="form-group">
                  <label>Heure début <span className="required">*</span></label>
                  <input 
                    type="time" 
                    name="heure_debut" 
                    value={formData.heure_debut} 
                    onChange={handleInputChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label>Heure fin <span className="required">*</span></label>
                  <input 
                    type="time" 
                    name="heure_fin" 
                    value={formData.heure_fin} 
                    onChange={handleInputChange}
                    required
                  />
                </div>
              </div>

              <div className="form-group">
                <label>Matière <span className="required">*</span></label>
                <select name="matiere" value={formData.matiere} onChange={handleInputChange} required>
                  {matieres.map((matiere, index) => (
                    <option key={index} value={matiere}>{matiere}</option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <label>Enseignant</label>
                <select name="enseignant_id" value={formData.enseignant_id} onChange={handleInputChange}>
                  <option value="">Sélectionner un enseignant</option>
                  {enseignants.map(ens => (
                    <option key={ens.id} value={ens.id}>{ens.nom} - {ens.matiere}</option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <label>Salle</label>
                <input 
                  type="text" 
                  name="salle" 
                  value={formData.salle} 
                  onChange={handleInputChange}
                  placeholder="Ex: Salle 101, Labo 1"
                />
              </div>

              <div className="form-actions">
                <button type="button" className="btn-delete" onClick={handleDeleteCours}>
                  🗑 Supprimer
                </button>
                <div className="form-actions-right">
                  <button type="button" className="btn-cancel" onClick={() => setShowEditModal(false)}>
                    Annuler
                  </button>
                  <button type="submit" className="btn-submit">
                    Enregistrer
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

export default AdminEmploiDuTemps;
